import React from 'react';

export default function PageTitle({ title, intro }) {
    return (
        <div className="py-2 py-md-5">
            <h1>
                {title}
            </h1>
            {intro && (
                <p>{intro}</p>
            )}
        </div>
    )
}